<div class="flex flex-col md:flex-row w-full justify-between items-center mb-8">
  <img [src]="imageUrl()" class="min-w-20 max-w-[80%] max-h-80 h-auto" />
  <div class="w-full flex flex-col items-center md:items-start md:ml-8 mb-2">
    <span class="w-full text-lg mb-2">{{ itemName() }}</span>
    <p-inputnumber
            [(ngModel)]="lineItem().quantity"
            (onInput)="updateElement(lineItem())"
            showButtons="true"
            [step]="1"
            size="small"
            [min]="1" 
            [max]="quantityAvailable()">
    </p-inputnumber>
    <span class="mt-1 text-sm !text-[var(--p-info-500)] font-semibold">
      Only {{ quantityAvailable() }} available
    </span>
  </div>

  <div class="w-full flex flex-row md:flex-col justify-between md:items-end">
    <span class="font-semibold md:mb-2">{{ lineTotal() }}</span>
    <button (click)="removeElementSignal.emit(lineItem())" class="text-slate-500">
      <fa-icon [icon]="icons.faTrashAlt" /> Remove
    </button>
  </div>
</div>